import React from 'react';

import styles from './marketingMaterialsReorderFormStyles';

import Link from 'buyside/components/presentation/Link/link';
import ReorderForm from 'buyside/components/presentation/Form/ReorderForm/reorderForm';

const renderMarketingMaterial = marketingMaterial => (
  <div className={styles.marketingMaterial}>
    <Link to="#">{marketingMaterial.name}</Link>
    <span>{marketingMaterial.category}</span>
  </div>
);

const MarketingMaterialsReorderForm = ({ ...props }) => {
  return (
    <ReorderForm
      attr="fundProfile.marketingMaterials"
      renderItem={renderMarketingMaterial}
      {...props}
    />
  );
};

export default MarketingMaterialsReorderForm;
